import React, { useState, useRef, useCallback, useMemo, useEffect } from 'react';
import '../app.css';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import RadioGroup from '@mui/material/RadioGroup';
import FormLabel from '@mui/material/FormLabel';
import Button from '@mui/material/Button';

import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import images from "./images";

import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { keyframes } from '@emotion/react';


export const PrometheusConfig = [
    { "key": "install", "label": "You want a fresh installation?", "type": "checkbox", "options": { "yes": false, "no": false } },
    { "key": "name", "label": "Name of the release", "type": "input" },
    { "key": "namespace", "label": "Namespace", "type": "input" },
    { "key": "mode", "label": "Enable Thanos Sidecar/Receiver component", "type": "checkbox", "options": { "sidecar": false, "receiver": false }, "doclink": "https://thanos.io/tip/components/sidecar.md/#sidecar" },
    { "key": "objStoreConfig", "label": "Object Storage", "type": "input", "doclink": "https://github.com/thanos-io/thanos/blob/main/docs/storage.md" }
]

export const ThanosConfig = [
    { "key": "install", "label": "You want a fresh installation?", "type": "checkbox", "options": { "yes": false, "no": false } },
    { "key": "name", "label": "Name of the release", "type": "input" },
    { "key": "namespace", "label": "Namespace", "type": "input" },
    {
        "key": "querier", "label": "Querier", "type": "array", "doclink": "https://thanos.io/tip/components/query.md/#querierquery",
        "data": [
            {
                "parentKey": "querier", "key": "name", "label": "Name", "type": "input",
            },
            {
                "parentKey": "querier", "key": "dedup", "label": "Enable deduplication", "type": "checkbox", "options": { "yes": false, "no": false }
            },
            {
                "parentKey": "querier", "key": "autodownsampling", "label": "Enable automatic adjustment", "type": "checkbox", "options": { "yes": false, "no": false }
            },
            {
                "parentKey": "querier", "key": "partialresponse", "label": "Enable partial response", "type": "checkbox", "options": { "yes": false, "no": false }
            },
        ]
    },
    {
        "key": "receiver", "label": "Receiver", "type": "array", "doclink": "https://thanos.io/tip/components/receive.md/#receiver",
        "data": [
            {
                "parentKey": "querierFE", "key": "name", "label": "Name", "type": "input",
            },

        ]
    },
    {
        "key": "querierFE", "label": "Querier Frontend", "type": "array", "doclink": "https://thanos.io/tip/components/query-frontend.md/#query-frontend",
        "data": [
            {
                "parentKey": "querierFE", "key": "name", "label": "Name", "type": "input",
            },
            {
                "parentKey": "querierFE", "key": "cacheOption", "label": "Cache Type", "type": "dropdown",
                "options":
                {
                    "inMemory": [
                        {
                            "key": "max_size_items", "label": "max_size_items", "type": "input", "parentKey": "querierFE.config",
                        },
                        {
                            "key": "validity", "label": "validity", "type": "input", "parentKey": "querierFE.config",

                        },
                        {
                            "key": "max_size", "label": "max_size", "type": "input", "parentKey": "querierFE.config",

                        },
                    ],
                    "memcached": [
                        {
                            "key": "timeout", "label": "timeout", "type": "input",
                        },
                        {
                            "key": "max_idle_connections", "label": "max_idle_connections", "type": "input",

                        },
                        {
                            "key": "max_async_concurrency", "label": "max_async_concurrency", "type": "input",

                        }, {
                            "key": "max_async_buffer_size", "label": "max_async_buffer_size", "type": "input",

                        }, {
                            "key": "max_get_multi_concurrency", "label": "max_get_multi_concurrency", "type": "input",

                        }, {
                            "key": "max_get_multi_batch_size", "label": "max_get_multi_batch_size", "type": "input",

                        }, {
                            "key": "dns_provider_update_interval", "label": "dns_provider_update_interval", "type": "input",

                        }, {
                            "key": "expiration", "label": "expiration", "type": "input",

                        },
                        {
                            "key": "addresses", "label": "addresses", "type": "input",

                        },
                    ],
                },
            },

        ]
    },
    {
        "key": "compactor", "label": "Compactor", "type": "array", "doclink": "https://thanos.io/tip/components/compact.md/#compactor",
        "data": [
            {
                "parentKey": "compactor", "key": "deduplication", "label": "Enable deduplication", "type": "checkbox", "options": { "yes": false, "no": false }
            },
            {
                "parentKey": "compactor", "key": "downsampling", "label": "Enable automatic adjustment", "type": "checkbox", "options": { "yes": false, "no": false }
            },
            {
                "parentKey": "compactor", "key": "name", "label": "Name", "type": "input",
            },
            { "parentKey": "compactor", "key": "retentionResolutionRaw", "label": "retentionResolutionRaw", "type": "input" },
            { "parentKey": "compactor", "key": "retentionResolution5m", "label": "retentionResolution5m", "type": "input" },
            { "parentKey": "compactor", "key": "retentionResolution1h", "label": "retentionResolution1h", "type": "input" },

        ]
    },
    { "key": "objStoreConfig", "label": "Object Storage", "type": "input", "doclink": "https://github.com/thanos-io/thanos/blob/main/docs/storage.md" }
]

export const ObjectStoreS3Config = [
    { "key": "name", "label": "Name", "type": "input", "required": true },
    { "key": "bucket", "label": "Bucket", "type": "input", "required": true },
    { "key": "endpoint", "label": "Endpoint", "type": "input", "required": true },
    { "key": "access_key", "label": "Access Key", "type": "input", "required": true },
    { "key": "secret_key", "label": "Secret Key", "type": "input", "required": true },
]

export const ObjectStoreGCSConfig = [
    { "key": "bucket", "label": "Bucket", "type": "input", "required": true },
    { "key": "name", "label": "Name", "type": "input", "required": true },
    { "key": "service_account", "label": "Service Account", "type": "input", "required": true },
]

export const ObjectStoreAzureBlobConfig = [
    { "key": "storage_account", "label": "Storage Account", "type": "input", "required": true },
    { "key": "name", "label": "Name", "type": "input", "required": true },
    { "key": "storage_account_key", "label": "Storage Account Key", "type": "input", "required": true },
    { "key": "container", "label": "Container", "type": "input", "required": true },
]

export const ObjectStoreMinioConfig = [
    { "key": "bucket", "label": "Bucket", "type": "input", "required": true },
    { "key": "name", "label": "Name", "type": "input", "required": true },
    { "key": "endpoint", "label": "Endpoint", "type": "input", "required": true },
    { "key": "access_key", "label": "Access Key", "type": "input", "required": true },
    { "key": "secret_key", "label": "Secret Key", "type": "input", "required": true },
    { "key": "region", "label": "Region", "type": "input", "required": true },
    { "key": "insecure", "label": "Insecure", "type": "checkbox", "options": { "yes": false, "no": false } }
]

export default ({ configNode, setConfigNode, setShowNodeConfig, onNodeDelete, }) => {
    const [data, setData] = useState(configNode.data);
    const [currentConfig, setCurrentConfig] = useState([]);
    function handleConfigChange(e, name, cc) {
        let key = cc.key
        if (cc.parentKey !== undefined) {

            var newData = { ...data }
            let parentKey = cc.parentKey

            var splitString = parentKey.split(".");

            if (splitString.length > 1) {
                let parentKey1 = splitString[0]
                let parentKey2 = splitString[1]
                if (typeof newData[parentKey1][parentKey2] == "undefined") {
                    newData[parentKey1][parentKey2] = {}
                }
                newData[parentKey1][parentKey2][key] = e.target.value

            } else {
                newData[parentKey][key] = e.target.value
            }
            setData(newData)
        } else {
            setData(prevState => ({
                ...prevState,
                [key]: e.target.value
            }))
        }
    }

    function handleConfigChangeRadio(e, cc) {
        let key = cc.key
        if (cc.parentKey !== undefined) {
            var someProperty = { ...data }
            let parentKey = cc.parentKey
            someProperty[parentKey][key] = e.target.value
            setData(someProperty)
        } else {
            setData(prevState => ({
                ...prevState,
                [key]: e.target.value
            }))
        }

    }
    function handleSaveConfig() {
        setConfigNode(prevState => ({
            ...prevState,
            data: data
        }));
        setShowNodeConfig(false)
    }
    useEffect(() => {
        if (data.label == "prometheus node") {
            setCurrentConfig(PrometheusConfig)
        }
        if (data.label == "thanos node") {
            setCurrentConfig(ThanosConfig)
        }
        if (data.type == "S3") {
            setCurrentConfig(ObjectStoreS3Config)
        }
        if (data.type == "AZURE") {
            setCurrentConfig(ObjectStoreAzureBlobConfig)
        }
        if (data.type == "GCS") {
            setCurrentConfig(ObjectStoreGCSConfig)
        }
        if (data.type == "minio") {
            setCurrentConfig(ObjectStoreMinioConfig)
        }
    }, [])

    function renderConfig(cc, key) {
        let ck = !cc.key ? key : cc.key
        let value = ck != key ? data[key][ck] : data[key]
        if (cc.parentKey && cc.parentKey != "") {
            var splitString = cc.parentKey.split(".");
            if (splitString.length > 1) {
                let parentKey1 = splitString[0]
                let parentKey2 = splitString[1]
                if (data[key].hasOwnProperty(parentKey2)) {
                    value = data[key][parentKey2][ck]

                }
            }
        }
        return (
            <div >
                {cc.doclink && cc.doclink != "" && <img
                    src={images.HelpIcon}
                    height="20px"
                    style={{ margin: 5, float: 'right' }}
                    className="on-hover-highlight"
                    onClick={(e) => {
                        e.preventDefault();
                        window.open(cc.doclink, "_blank")
                    }} />}
                {cc.type == "checkbox" &&
                    <div>
                        <FormControl>
                            <FormLabel id="demo-radio-buttons-group-label">{cc.label}</FormLabel>
                            <RadioGroup
                                aria-labelledby="demo-controlled-radio-buttons-group"
                                value={data[key]}
                                name="controlled-radio-buttons-group"
                                onChange={(e) => handleConfigChangeRadio(e, cc)}
                            >
                                {cc.options && Object.keys(cc.options).map((keyName, keyIndex) => {
                                    return (
                                        <FormControlLabel
                                            value={keyName}
                                            control={<Radio checked={ck != key ?
                                                data[key][ck] == keyName : data[key] == keyName} />}
                                            label={keyName}
                                        />
                                    )
                                })}
                            </RadioGroup>
                        </FormControl>
                    </div>
                }

                {cc.type == "input" &&
                    <>
                        <TextField
                            disabled={cc.key == "objStoreConfig" ? true : false}
                            id="outlined-basic"
                            label={cc.label}
                            variant="standard"
                            required={cc.required}
                            onChange={(e) => handleConfigChange(e, key, cc)}
                            defaultValue={value}
                        />

                    </>
                }

                {cc.type == "dropdown" &&
                    <>
                        <FormControl style={{ marginTop: 15 }} fullWidth>
                            <InputLabel id="demo-simple-select-label">{cc.label}</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                label={cc.label}
                                value={value}
                                onChange={(e) => handleConfigChange(e, key, cc)}
                            >

                                {
                                    Object.keys(cc.options).map((key) => (
                                        <MenuItem value={key}>{key}</MenuItem>))
                                }
                            </Select>
                        </FormControl>
                        {value && cc.options && cc.options[value].map(ccc => {
                            return (
                                renderConfig(ccc, key)
                            )
                        })}
                    </>
                }

                {cc.type == "array" && <div>
                    <span style={{ fontWeight: 'bold', marginTop: 10, marginBottom: 10, display: 'block', color: '#000000b0' }}>
                        <u>{cc.label} config</u>
                    </span>
                    {cc.data.map(ccc => {
                        return (
                            renderConfig(ccc, key)
                        )
                    })}
                </div>}

            </div>)
    }
    return (
        <div className="sidenav">
            <div style={{
                borderBottom: "1px solid #dccdcd",
                padding: 10
            }}>
                <Button variant="outlined" style={{ height: 28, textTransform: 'capitalize', }}
                    onClick={() => handleSaveConfig()}
                >Save</Button>

                <Button variant="contained" style={{ margin: "10px", height: 28, textTransform: 'capitalize', }}
                    onClick={(e) => onNodeDelete(e, configNode)
                    }
                > Delete Node</Button>
                <IconButton
                    aria-label="close"
                    onClick={() => setShowNodeConfig(false)}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>

            </div>
            {
                Object.keys(data).map(function (key) {
                    if (key != "label") {
                        return (
                            <div style={{
                                padding: "6px 6px 10px 6px",
                                borderBottom: "1px solid #dccdcd"
                            }}>
                                {currentConfig.map(cc => {
                                    if (cc.key == key) {
                                        return (
                                            renderConfig(cc, key)
                                        )
                                    }
                                }
                                )}
                            </div>
                        )
                    }
                })
            }
        </div >
    );
};
